<div class="admin-layout">

  <!-- Left nav -->
  <nav class="admin-nav">
    <h2 class="admin-nav-title">Admin</h2>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'documents'"
      (click)="selectPanel('documents')"
    >
      <ngk-icon icon="file-text" size="1rem"/>
      <span>Documents</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'admins'"
      (click)="selectPanel('admins')"
    >
      <ngk-icon icon="shield" size="1rem"/>
      <span>Users</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'stats'"
      (click)="selectPanel('stats')"
    >
      <ngk-icon icon="bar-chart-2" size="1rem"/>
      <span>Stats</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'signatures'"
      (click)="selectPanel('signatures')"
    >
      <ngk-icon icon="user" size="1rem"/>
      <span>Manage User</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'data'"
      (click)="selectPanel('data')"
    >
      <ngk-icon icon="upload" size="1rem"/>
      <span>Data</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'jobs'"
      (click)="selectPanel('jobs')"
    >
      <ngk-icon icon="list" size="1rem"/>
      <span>Jobs</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'dedup'"
      (click)="selectPanel('dedup')"
    >
      <ngk-icon icon="copy" size="1rem"/>
      <span>Dedup Emails</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'evidence'"
      (click)="selectPanel('evidence')"
    >
      <ngk-icon icon="file-text" size="1rem"/>
      <span>Evidence Packet</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'evidenceBatch'"
      (click)="selectPanel('evidenceBatch')"
    >
      <ngk-icon icon="file-text" size="1rem"/>
      <span>Evidence Batch</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'steps'"
      (click)="selectPanel('steps')"
    >
      <ngk-icon icon="list" size="1rem"/>
      <span>Case Steps</span>
    </button>
    <button
      class="admin-nav-item"
      [class.admin-nav-item--active]="activePanel === 'countyMapping'"
      (click)="selectPanel('countyMapping')"
    >
      <ngk-icon icon="map-pin" size="1rem"/>
      <span>County Mapping (Preview)</span>
    </button>
  </nav>

  <!-- Right content -->
  <main class="admin-content">

    <!-- Documents panel -->
    @if (activePanel === 'documents') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Download Documents</h3>
        <p class="admin-panel-desc">Download all documents for every user as a single zip file.</p>

        <button ngkButton color="secondary" mode="solid" size="sm" (click)="downloadAllDocuments()">
          <ngk-icon icon="download" size="1rem"/>
          Download All Documents
        </button>

        @if (downloadAllError) {
          <p class="admin-error">{{ downloadAllError }}</p>
        }
      </div>
    }

    <!-- Manage Admins panel -->
    @if (activePanel === 'admins') {
      <div class="admin-panel admin-panel--wide">
        <h3 class="admin-panel-title">Users</h3>
        <p class="admin-panel-desc">View all users, filter by attributes, and manage admin access.</p>

        @if (usersLoading) {
          <p class="admin-loading">Loading users…</p>
        }

        @if (usersError) {
          <p class="admin-error">{{ usersError }}</p>
          <button ngkButton color="secondary" mode="outlined" size="sm" (click)="loadUsers()">Retry</button>
        }

        @if (!usersLoading && users.length > 0) {
          <div class="admin-filters">
            <input
              class="admin-input"
              type="text"
              placeholder="Search by email, phone, name, or step…"
              [(ngModel)]="userSearch"
            />
            <select class="admin-select" [(ngModel)]="userFilterAdmin">
              <option value="all">All roles</option>
              <option value="admin">Admins only</option>
              <option value="non-admin">Non-admins only</option>
            </select>
            <select class="admin-select" [(ngModel)]="userFilterStep">
              <option value="all">All steps</option>
              <option value="has-step">Has current step</option>
              <option value="no-step">No current step</option>
            </select>
            <select class="admin-select" [(ngModel)]="userFilterSigned">
              <option value="all">All signing</option>
              <option value="signed">Signed</option>
              <option value="unsigned">Not signed</option>
            </select>
            <select class="admin-select" [(ngModel)]="userFilterLogin">
              <option value="all">All logins</option>
              <option value="has-login">Has logged in</option>
              <option value="no-login">Never logged in</option>
            </select>
          </div>

          <div class="admin-btn-row">
            <button ngkButton color="secondary" mode="solid" size="sm" (click)="downloadUsersCsv()">
              <ngk-icon icon="download" size="1rem"/>
              Download CSV
            </button>
            <button ngkButton color="secondary" mode="outlined" size="sm" (click)="loadUsers()">
              Refresh
            </button>
            <span class="admin-user-name">{{ filteredUsers.length }} of {{ users.length }} users</span>
          </div>

          <div class="admin-table-wrap">
            <table class="admin-table">
              <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Parcel ID</th>
                <th>County</th>
                <th>Assessed Value</th>
                <th>Tax Year</th>
                <th>Current Step</th>
                <th>Signed</th>
                <th>Admin</th>
                <th>Last Login</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                @for (user of filteredUsers; track user.id) {
                  <tr>
                    <td class="admin-table-email">{{ user.email }}</td>
                    <td>{{ user.firstName || '' }} {{ user.lastName ? (user.lastName | titlecase) : '' }}</td>
                    <td>{{ user.phoneNumber || '—' }}</td>
                    <td>{{ user.address || '—' }}</td>
                    <td>{{ user.parcelId || '—' }}</td>
                    <td>{{ user.county || '—' }}</td>
                    <td>{{ user.assessedValue !== null ? (user.assessedValue | number) : '—' }}</td>
                    <td>{{ user.assessedValueTaxYear ?? '—' }}</td>
                    <td>{{ user.currentStep || '—' }}</td>
                    <td>
                      @if (user.hasSigned) {
                        <ngk-chip color="secondary" variant="solid" size="sm">Yes</ngk-chip>
                      } @else {
                        <span class="admin-user-name">No</span>
                      }
                    </td>
                    <td>
                      @if (user.isAdmin) {
                        <ngk-chip color="secondary" variant="solid" size="sm">Admin</ngk-chip>
                      } @else {
                        <span class="admin-user-name">User</span>
                      }
                    </td>
                    <td>{{ user.lastLoginAt ? (user.lastLoginAt | date:'short') : '—' }}</td>
                    <td>{{ user.createdAt | date:'short' }}</td>
                    <td class="admin-table-actions">
                      @if (user.isAdmin) {
                        <button
                          class="admin-toggle-btn admin-toggle-btn--demote"
                          [disabled]="adminActionLoading === user.id"
                          (click)="toggleAdmin(user)"
                        >
                          {{ adminActionLoading === user.id ? '…' : 'Demote' }}
                        </button>
                      } @else if (user.email.endsWith('@kin.com')) {
                        <button
                          class="admin-toggle-btn"
                          [disabled]="adminActionLoading === user.id"
                          (click)="toggleAdmin(user)"
                        >
                          {{ adminActionLoading === user.id ? '…' : 'Make Admin' }}
                        </button>
                      }
                      <button class="admin-download-btn" (click)="downloadUserDocuments(user)"
                              title="Download documents">
                        <ngk-icon icon="download" size="0.85rem"/>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        @if (adminActionError) {
          <p class="admin-error">{{ adminActionError }}</p>
        }
        @if (downloadError) {
          <p class="admin-error">{{ downloadError }}</p>
        }

        @if (!usersLoading && !usersError && users.length === 0) {
          <p class="admin-empty">No users found.</p>
        }
      </div>
    }

    <!-- Stats panel -->
    @if (activePanel === 'stats') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Signed Contracts</h3>
        <p class="admin-panel-desc">Number of users who have signed a document.</p>

        @if (signedCountLoading) {
          <p class="admin-loading">Loading…</p>
        }

        @if (signedCountError) {
          <p class="admin-error">{{ signedCountError }}</p>
          <button ngkButton color="secondary" mode="outlined" size="sm" (click)="loadSignedCount()">Retry</button>
        }

        @if (signedCount !== null && !signedCountLoading) {
          <p class="admin-stat-value">{{ signedCount }}</p>
          <div class="admin-btn-row">
            <button ngkButton color="secondary" mode="solid" size="sm" (click)="loadSignedCount()">Refresh</button>
          </div>
        }
      </div>
    }

    <!-- Manage User panel -->
    @if (activePanel === 'signatures') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Look Up User</h3>
        <p class="admin-panel-desc">Search for a user by email to view their details and manage their addresses.</p>

        <div class="admin-form">
          <label class="admin-label" for="lookup-email">User email</label>
          <div class="admin-input-row">
            <input
              id="lookup-email"
              class="admin-input"
              type="email"
              placeholder="user@example.com"
              [(ngModel)]="lookupEmail"
              (keydown.enter)="searchUser()"
            />
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="lookupLoading || !lookupEmail.trim()"
              (click)="searchUser()"
            >
              {{ lookupLoading ? 'Searching…' : 'Search' }}
            </button>
          </div>
        </div>

        @if (lookupError) {
          <p class="admin-error">{{ lookupError }}</p>
        }

        @if (lookupUser) {
          <div class="admin-user-detail">
            <h4 class="admin-panel-title">{{ lookupUser.email }}</h4>
            <p class="admin-panel-desc">
              @if (lookupUser.firstName) {
                {{ lookupUser.firstName }} ·
              }
              @if (lookupUser.phoneNumber) {
                {{ lookupUser.phoneNumber }} ·
              }
              {{ lookupUser.isAdmin ? 'Admin' : 'User' }}
            </p>
            @if (lookupUser.legalDescription) {
              <p class="admin-panel-desc">Legal description: {{ lookupUser.legalDescription }}</p>
            }

            @if (lookupUser.properties.length > 0) {
              <h4 class="admin-label admin-label--spaced">Linked Parcels</h4>
              <div class="admin-user-list">
                @for (prop of lookupUser.properties; track propertyKey(prop)) {
                  <div class="admin-user-row">
                    <div class="admin-user-info">
                      <span class="admin-user-email">{{ prop.parcelId }}</span>
                      <span class="admin-user-name">{{ prop.county }}</span>
                    </div>
                    <div class="admin-user-actions">
                      <button
                        class="admin-toggle-btn admin-toggle-btn--demote"
                        [disabled]="propertyDeleting === propertyKey(prop)"
                        (click)="deleteProperty(prop)"
                      >
                        {{ propertyDeleting === propertyKey(prop) ? '…' : 'Delete' }}
                      </button>
                    </div>
                  </div>
                }
              </div>
              @if (propertyDeleteError) {
                <p class="admin-error">{{ propertyDeleteError }}</p>
              }
            }

            @if (lookupUser.addresses.length > 0) {
              <h4 class="admin-label admin-label--spaced">Addresses</h4>
              <div class="admin-user-list">
                @for (addr of lookupUser.addresses; track addr.id) {
                  <div class="admin-user-row">
                    <div class="admin-user-info">
                      <span class="admin-user-email">{{ addr.street }}@if (addr.unit) {
                        , {{ addr.unit }}
                      }</span>
                      <span class="admin-user-name">{{ addr.city }}, {{ addr.state }} {{ addr.zip }}</span>
                    </div>
                    <div class="admin-user-actions">
                      <button
                        class="admin-toggle-btn admin-toggle-btn--demote"
                        [disabled]="addressDeleting === addr.id"
                        (click)="deleteAddress(addr.id)"
                      >
                        {{ addressDeleting === addr.id ? '…' : 'Delete' }}
                      </button>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="admin-empty">No addresses found for this user.</p>
            }

            @if (addressDeleteError) {
              <p class="admin-error">{{ addressDeleteError }}</p>
            }

            <h4 class="admin-label admin-label--spaced">Payments</h4>
            @if (lookupPaymentsLoading) {
              <p class="admin-loading">Loading payments…</p>
            }
            @if (lookupPaymentsError) {
              <p class="admin-error">{{ lookupPaymentsError }}</p>
            }
            @if (lookupPayments) {
              <p class="admin-panel-desc admin-partner-agreed">
                Partner terms:
                @if (lookupPayments.partnerAgreedAt) {
                  agreed {{ lookupPayments.partnerAgreedAt | date: 'medium' }}
                } @else {
                  not agreed
                }
              </p>

              <!-- Sits beside the agreement because an admin about to mark someone ineligible
                   needs to see whether they already are. Read from the partner-ineligible
                   endpoint on every lookup: "not marked" is the server's answer, not a guess.
                   Only a failed read says unknown, and it never falls back to eligible. -->
              <p class="admin-panel-desc admin-partner-ineligible">
                Partner eligibility:
                @if (lookupIneligibleLoading) {
                  reading…
                } @else if (lookupIneligibleKnown) {
                  @if (lookupIneligibleAt) {
                    <strong>marked ineligible</strong> {{ lookupIneligibleAt | date: 'medium' }}
                  } @else {
                    not marked
                  }
                } @else {
                  unknown — {{ lookupIneligibleError || 'the eligibility read did not complete.' }}
                }
              </p>

              @if (lookupPayments.payments.length > 0) {
                <div class="admin-user-list">
                  @for (pay of lookupPayments.payments; track pay.id) {
                    <div class="admin-payment-row">
                      <div class="admin-payment-head">
                        <span class="admin-payment-status" [class]="'admin-payment-status--' + pay.status">{{ pay.status }}</span>
                        <span class="admin-payment-amount">
                          {{ pay.amountCents / 100 | currency: (pay.currency | uppercase) }}
                          @if (pay.amountRefundedCents) {
                            <span class="admin-payment-refunded">({{ pay.amountRefundedCents / 100 | currency: (pay.currency | uppercase) }} refunded)</span>
                          }
                        </span>
                      </div>
                      @if (pay.awaitingWebhook) {
                        <p class="admin-payment-note">
                          Unsettled — this row may be awaiting a Stripe webhook rather than being genuinely unpaid.
                          Check the session in Stripe before assuming the user did not pay.
                        </p>
                      }
                      <dl class="admin-payment-fields">
                        <div class="admin-payment-field">
                          <dt>Created</dt>
                          <dd>{{ pay.createdAt | date: 'medium' }}</dd>
                        </div>
                        <div class="admin-payment-field">
                          <dt>Paid</dt>
                          <dd>{{ pay.paidAt ? (pay.paidAt | date: 'medium') : '—' }}</dd>
                        </div>
                        <div class="admin-payment-field">
                          <dt>Refunded</dt>
                          <dd>{{ pay.refundedAt ? (pay.refundedAt | date: 'medium') : '—' }}</dd>
                        </div>
                        <div class="admin-payment-field">
                          <dt>Checkout session</dt>
                          <dd class="admin-payment-id" [title]="pay.stripeSessionId">{{ pay.stripeSessionId }}</dd>
                        </div>
                        <div class="admin-payment-field">
                          <dt>Payment intent</dt>
                          <dd class="admin-payment-id" [title]="pay.stripePaymentIntentId || ''">{{ pay.stripePaymentIntentId || '—' }}</dd>
                        </div>
                      </dl>
                    </div>
                  }
                </div>
              } @else {
                <p class="admin-empty">No payments found for this user.</p>
              }

              @if (lookupPayments.notes.length > 0) {
                <ul class="admin-payment-notes">
                  @for (note of lookupPayments.notes; track note) {
                    <li>{{ note }}</li>
                  }
                </ul>
              }
            }
          </div>
        }

        <hr class="admin-divider"/>

        <h3 class="admin-panel-title">Link Email to Parcel</h3>
        <p class="admin-panel-desc">Associate a user's email address with a parcel in a county so they can view their
          property assessment.</p>

        <div class="admin-form">
          <label class="admin-label" for="link-email">Email</label>
          <input
            id="link-email"
            class="admin-input"
            type="email"
            placeholder="user@example.com"
            [(ngModel)]="linkEmail"
          />

          <label class="admin-label admin-label--spaced" for="link-county">County</label>
          <select
            id="link-county"
            class="admin-select"
            [(ngModel)]="linkCounty"
          >
            <option value="" disabled>Select county</option>
            @for (c of publicCounties; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>

          <label class="admin-label admin-label--spaced" for="link-parcel-id">Parcel ID</label>
          <input
            id="link-parcel-id"
            class="admin-input"
            type="text"
            placeholder="e.g. 1000480000070"
            [(ngModel)]="linkParcelId"
          />

          <label class="admin-label admin-label--spaced" for="link-year">Tax Year</label>
          <input
            id="link-year"
            class="admin-input admin-input--short"
            type="number"
            [(ngModel)]="linkTaxYear"
          />

          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="linkLoading || !linkEmail.trim() || !linkCounty || !linkParcelId.trim()"
              (click)="submitLinkEmail()"
            >
              {{ linkLoading ? 'Linking…' : 'Link Email' }}
            </button>
          </div>
        </div>

        @if (linkSuccess) {
          <div class="admin-link-result">
            <p class="admin-success">Linked {{ linkSuccess.email }} to parcel {{ linkSuccess.parcelId }} in {{ linkSuccess.county }}</p>
            <p class="admin-link-address">{{ linkSuccess.street }}, {{ linkSuccess.cityStateZip }}</p>
          </div>
        }
        @if (linkError) {
          <p class="admin-error">{{ linkError }}</p>
        }

        <hr class="admin-divider"/>

        <h3 class="admin-panel-title">Delete Signature Requests</h3>
        <p class="admin-panel-desc">Remove all signature requests for a user so they can re-sign.</p>

        <div class="admin-form">
          <label class="admin-label" for="sig-email">User email</label>
          <div class="admin-input-row">
            <input
              id="sig-email"
              class="admin-input"
              type="email"
              placeholder="user@example.com"
              [(ngModel)]="sigEmail"
              (keydown.enter)="deleteSignatureRequests()"
            />
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="sigDeleting || !sigEmail.trim()"
              (click)="deleteSignatureRequests()"
            >
              {{ sigDeleting ? 'Deleting…' : 'Delete' }}
            </button>
          </div>
        </div>

        @if (sigSuccess) {
          <p class="admin-success">{{ sigSuccess }}</p>
        }
        @if (sigError) {
          <p class="admin-error">{{ sigError }}</p>
        }

        <hr class="admin-divider"/>

        <h3 class="admin-panel-title">Reset Partner State</h3>
        <p class="admin-panel-desc">Clears the user's partner agreement and removes their unsettled payment rows so they
          can run the <code>/partner</code> flow again. Pending rows are reconciled against Stripe first: any that
          actually succeeded are promoted to paid and kept. It never deletes paid or refunded rows — to reset a user who
          has paid, refund the charge in Stripe first (the <code>charge.refunded</code> webhook flips the row to
          refunded), then run this.</p>

        <div class="admin-form">
          <label class="admin-label" for="reset-partner-email">User email</label>
          <div class="admin-input-row">
            <input
              id="reset-partner-email"
              class="admin-input"
              type="email"
              placeholder="user@example.com"
              [(ngModel)]="resetEmail"
              (keydown.enter)="resetPartnerState()"
            />
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="resetting || !resetEmail.trim()"
              (click)="resetPartnerState()"
            >
              {{ resetting ? 'Resetting…' : 'Reset' }}
            </button>
          </div>
        </div>

        @if (resetResult) {
          <div class="admin-reset-result">
            <p class="admin-success">Partner state reset for {{ resetResult.email }}.</p>
            <ul class="admin-reset-summary">
              <li>
                {{ resetResult.agreementCleared ? 'Partner agreement cleared.' : 'No partner agreement was set — nothing to clear.' }}
              </li>
              @if (resetResult.payments.reconciledToPaid > 0) {
                <li class="admin-reset-highlight">
                  {{ resetResult.payments.reconciledToPaid }} pending row(s) were confirmed as succeeded in Stripe,
                  promoted to <strong>paid</strong> and kept — they were <strong>not</strong> deleted.
                </li>
              }
              @if (resetResult.payments.pendingSkippedUnreconciled > 0) {
                <li class="admin-reset-highlight">
                  {{ resetResult.payments.pendingSkippedUnreconciled }} pending row(s) were kept, not deleted, because
                  Stripe could not be reached or is not configured. An unverified pending row can be the only link to a
                  real charge. Re-run this once Stripe is reachable.
                </li>
              }
              <li>
                Deleted: {{ resetResult.payments.deleted.pending }} pending,
                {{ resetResult.payments.deleted.failed }} failed.
              </li>
              <li>
                Kept: {{ resetResult.payments.kept.paid }} paid, {{ resetResult.payments.kept.refunded }} refunded.
              </li>
              @if (resetResult.payments.kept.paid > 0) {
                <li class="admin-reset-highlight">
                  A paid row survived, so this user still counts as paid and will not see the payment step. Refund the
                  charge in Stripe to fully reset them.
                </li>
              }
            </ul>
            @if (resetResult.notes.length > 0) {
              <ul class="admin-reset-notes">
                @for (note of resetResult.notes; track note) {
                  <li>{{ note }}</li>
                }
              </ul>
            }
          </div>
        }
        @if (resetError) {
          <p class="admin-error">{{ resetError }}</p>
        }

        <hr class="admin-divider"/>

        <h3 class="admin-panel-title">Partner Ineligible</h3>
        <p class="admin-panel-desc">Marks the user as no longer eligible, so <code>/partner</code> tells them their
          appeal is not moving ahead instead of inviting them to pay again. Use it after Abode declines a case.
          <strong>This does not issue a refund</strong> and does not touch any payment row — refunds happen in Stripe,
          and the <code>charge.refunded</code> webhook records them. Refund there <strong>first</strong>, then mark:
          the page states the refund as fact, so marking an unrefunded user tells them their money is coming back when
          it isn't. Un-mark reverses it.</p>

        <div class="admin-form">
          <label class="admin-label" for="ineligible-email">User email</label>
          <div class="admin-input-row">
            <input
              id="ineligible-email"
              class="admin-input"
              type="email"
              placeholder="user@example.com"
              [(ngModel)]="ineligibleEmail"
              (keydown.enter)="markPartnerIneligible()"
            />
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="ineligibleBusy !== null || !ineligibleEmail.trim()"
              (click)="markPartnerIneligible()"
            >
              {{ ineligibleBusy === 'mark' ? 'Marking…' : 'Mark Ineligible' }}
            </button>
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="ineligibleBusy !== null || !ineligibleEmail.trim()"
              (click)="clearPartnerIneligible()"
            >
              {{ ineligibleBusy === 'unmark' ? 'Un-marking…' : 'Un-mark' }}
            </button>
          </div>
        </div>

        <!-- `changed` is what separates a real change from a successful no-op, so the four
             cases are spelled out rather than collapsed into one "done" message. Re-marking
             someone already marked must not claim it did something. -->
        @if (ineligibleResult) {
          <div class="admin-reset-result">
            @if (ineligibleResult.partnerIneligibleAt) {
              @if (ineligibleResult.changed) {
                <p class="admin-success">Marked {{ ineligibleResult.email }} ineligible as of
                  {{ ineligibleResult.partnerIneligibleAt | date: 'medium' }}.</p>
              } @else {
                <p class="admin-success">{{ ineligibleResult.email }} was <strong>already ineligible</strong> — no
                  change. Marked {{ ineligibleResult.partnerIneligibleAt | date: 'medium' }}.</p>
              }
              <ul class="admin-reset-summary">
                <li class="admin-reset-highlight">
                  No refund was issued and no payment row was touched. If the
                  {{ ineligibleResult.changed ? '$70 has not already been refunded' : 'charge was never refunded' }}
                  in Stripe, this page is now telling the user their money is on its way back when it isn't.
                </li>
              </ul>
            } @else {
              @if (ineligibleResult.changed) {
                <p class="admin-success">Cleared the ineligible flag for {{ ineligibleResult.email }}. They will see
                  the normal <code>/partner</code> flow again.</p>
              } @else {
                <p class="admin-success">{{ ineligibleResult.email }} was <strong>not marked ineligible</strong> — no
                  change.</p>
              }
            }
            @if (ineligibleResult.notes.length > 0) {
              <ul class="admin-reset-notes">
                @for (note of ineligibleResult.notes; track note) {
                  <li>{{ note }}</li>
                }
              </ul>
            }
          </div>
        }
        @if (ineligibleError) {
          <p class="admin-error">{{ ineligibleError }}</p>
        }

        <hr class="admin-divider"/>

        <!-- Deliberately its own section with its own input, NOT nested in the Look Up User
             result: that result only renders when a `users` row exists, and the case this
             answers is an email with a lead and no account. -->
        <h3 class="admin-panel-title">Partner Lead Lookup</h3>
        <p class="admin-panel-desc">Answers one question: <strong>was a partner lead imported for this
          email?</strong> That is independent of whether the person has ever logged in. A user account is only
          created when someone requests a login code, so <em>"No user found"</em> in Look Up User above says
          <strong>nothing</strong> about whether their lead imported — and a lead can exist here for an email with
          no account at all. This reads the partner lead rows directly.</p>

        <div class="admin-form">
          <label class="admin-label" for="lead-email">Lead email</label>
          <div class="admin-input-row">
            <input
              id="lead-email"
              class="admin-input"
              type="email"
              placeholder="user@example.com"
              [(ngModel)]="leadEmail"
              (keydown.enter)="searchPartnerLead()"
            />
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="leadLoading || !leadEmail.trim()"
              (click)="searchPartnerLead()"
            >
              {{ leadLoading ? 'Searching…' : 'Look Up Lead' }}
            </button>
          </div>
        </div>

        @if (leadResult) {
          <div class="admin-lead-result">
            @if (leadResult.found && leadResult.lead) {
              <p class="admin-success">A partner lead was imported for {{ leadResult.email }}.</p>
              <!-- updatedAt first: imports upsert in place, so it is what separates a row from
                   this morning's run from one left over from a file three weeks ago. -->
              <p class="admin-lead-updated">Last imported / updated:
                <strong>{{ leadResult.lead.updatedAt | date: 'medium' }}</strong></p>
              <ul class="admin-lead-fields">
                <li>Name: {{ leadName(leadResult.lead) }}</li>
                <li>Phone: {{ leadResult.lead.phone || 'not provided' }}</li>
                <li>Address: {{ leadResult.lead.addressSummary || 'not provided' }}</li>
                <li>County: {{ leadResult.lead.county || 'not provided' }}</li>
                <li>Estimate tier: {{ leadResult.lead.estimateTier || 'not provided' }}</li>
                <li>Estimated savings (Abode's figure): {{ leadMoney(leadResult.lead.estimatedSavings) }}</li>
                <li>Savings shown to the customer (capped): {{ leadMoney(leadResult.lead.savingsDisplayCapped) }}</li>
                <li>Deep link stored: {{ leadResult.lead.hasDeepLink ? 'Yes' : 'No' }}</li>
                <li>Lead UUID: {{ leadResult.lead.partnerLeadUuid || 'not provided' }}</li>
                <li>Abode created: {{ leadResult.lead.partnerCreatedAt ? (leadResult.lead.partnerCreatedAt | date: 'medium') : 'not provided' }}</li>
                <li>First imported: {{ leadResult.lead.createdAt | date: 'medium' }}</li>
              </ul>
            } @else {
              <!-- A normal, useful answer — not an error, and deliberately not styled as one. -->
              <p class="admin-lead-none">No partner lead has been imported for {{ leadResult.email }}.</p>
            }
            <!-- Shown on both branches: "no lead and 0 total" is a failed import, "no lead and
                 25,324" is one missing person. The two numbers only mean something together. -->
            <p class="admin-lead-count">Total partner leads in the table:
              <strong>{{ leadResult.totalPartnerLeadCount | number }}</strong>
              @if (!leadResult.found && leadResult.totalPartnerLeadCount === 0) {
                — the table is empty, so the import itself has not landed.
              }
            </p>
          </div>
        }
        @if (leadError) {
          <p class="admin-error">{{ leadError }}</p>
        }
      </div>
    }

    <!-- Data panel (unified upload + ingest) -->
    @if (activePanel === 'data') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Data Upload & Ingest</h3>
        <p class="admin-panel-desc">Pick a source and tax year, choose a file, then click Upload &amp; Ingest. Ingest
          starts automatically when the upload completes. Status appears below.</p>

        @if (dataSourcesLoading) {
          <p class="admin-loading">Loading data sources…</p>
        }
        @if (dataSourcesError) {
          <p class="admin-error">{{ dataSourcesError }}</p>
        }

        @if (!dataSourcesLoading && dataSources.length > 0) {
          <div class="admin-form">
            <label class="admin-label" for="data-type">Source</label>
            <select
              id="data-type"
              class="admin-input admin-input--medium"
              [(ngModel)]="dataSelectedType"
              (change)="onDataTypeChange()"
            >
              @for (s of dataSources; track s.id) {
                <option [value]="s.id">{{ s.label }}</option>
              }
            </select>

            @if (selectedDataSource) {
              <p class="admin-panel-desc">{{ selectedDataSource.description }}</p>

              @if (selectedDataSource.upload.params?.includes('county')) {
                <label class="admin-label admin-label--spaced" for="data-county">County</label>
                <select
                  id="data-county"
                  class="admin-select"
                  [(ngModel)]="dataCounty"
                >
                  <option value="" disabled>Select county</option>
                  @for (c of selectedDataSource.upload.paramEnums?.['county'] ?? []; track c) {
                    <option [value]="c">{{ c }}</option>
                  }
                </select>
              }

              @if (selectedDataSource.upload.params?.includes('year') || selectedDataSource.ingest.params?.includes('year')) {
                <label class="admin-label admin-label--spaced" for="data-year">Tax Year</label>
                <select
                  id="data-year"
                  class="admin-input admin-input--short"
                  [(ngModel)]="dataYear"
                >
                  @for (y of dataYearOptions; track y) {
                    <option [value]="y">{{ y }}</option>
                  }
                </select>
              }

              @if (selectedDataSource.ingest.params?.includes('parcelsUploadJobId')) {
                <label class="admin-label admin-label--spaced" for="data-parcels-upload-job-id">Parcels Upload Job ID</label>
                <input
                  id="data-parcels-upload-job-id"
                  class="admin-input admin-input--medium"
                  type="text"
                  placeholder="e.g. 6e2f1d9a-..."
                  [(ngModel)]="dataParcelsUploadJobId"
                />
                <p class="admin-panel-desc">Optional — job ID of a completed Parcels List CSV upload to filter
                  ingestion to a subset of parcels.</p>
              }

              @if (selectedDataSource.upload.supported) {
                <label class="admin-label admin-label--spaced" for="data-file">
                  File
                  @if (selectedDataSource.upload.accept && selectedDataSource.upload.accept.length > 0) {
                    <span>({{ selectedDataSource.upload.accept.join(', ') }})</span>
                  }
                </label>
                <input
                  id="data-file"
                  class="admin-file-input"
                  type="file"
                  [accept]="selectedDataSource.upload.accept?.join(',') ?? ''"
                  (change)="onDataFileChange($event)"
                />
                @if (dataFile) {
                  <p class="admin-file-name">{{ dataFile.name }}</p>
                }

                <div class="admin-btn-row">
                  <button
                    ngkButton color="warning" mode="solid" size="sm"
                    [disabled]="dataUploadStarting || !dataFile || !dataYearValidForSource || !dataCountyValidForSource || (dataUploadJob !== null && jobIsActive(dataUploadJob)) || (dataIngestJob !== null && jobIsActive(dataIngestJob))"
                    (click)="submitDataUpload()"
                  >
                    @if (dataUploadStarting) {
                      Uploading…
                    } @else if (selectedDataSource.ingest.supported) {
                      Upload & Ingest
                    } @else {
                      Upload
                    }
                  </button>
                </div>
              }

              @if (selectedDataSource.ingest.supported && !selectedDataSource.upload.supported) {
                <div class="admin-btn-row">
                  <button
                    ngkButton color="warning" mode="solid" size="sm"
                    [disabled]="dataIngestStarting || !dataYearValidForSource || (dataIngestJob !== null && jobIsActive(dataIngestJob))"
                    (click)="submitDataIngest()"
                  >
                    {{ dataIngestStarting ? 'Starting…' : 'Start Ingest' }}
                  </button>
                </div>
              }
            }
          </div>

          @if (dataUploadJob || dataUploadError || dataIngestJob || dataIngestSuccess || dataIngestError) {
            <div class="admin-restore-status admin-data-status">
              @if (selectedDataSource?.upload?.supported) {
                <div class="admin-data-step">
                  <span class="admin-data-step-icon">
                    @if (dataUploadJob?.status === 'completed') {
                      ✓
                    } @else if (dataUploadError) {
                      ✗
                    } @else if (dataUploadJob && jobIsActive(dataUploadJob)) {
                      ⏳
                    } @else {
                      ·
                    }
                  </span>
                  <span>
                    <strong>Step 1 — Upload.</strong>
                    @if (dataUploadJob) {
                      @switch (dataUploadJob.status) {
                        @case ('pending') {
                          Pending…
                        }
                        @case ('uploading_to_s3') {
                          Uploading file…
                        }
                        @case ('running') {
                          Running…
                        }
                        @case ('completed') {
                          Complete.
                        }
                        @default {
                          {{ dataUploadJob.status }}
                        }
                      }
                    } @else if (dataUploadError) {
                      {{ dataUploadError }}
                    } @else {
                      Not started.
                    }
                  </span>
                  @if (dataUploadJob && jobIsActive(dataUploadJob)) {
                    <button ngkButton color="warning" mode="outlined" size="sm" (click)="cancelDataUpload()">
                      Cancel
                    </button>
                  }
                </div>
              }

              @if (selectedDataSource?.ingest?.supported) {
                <div class="admin-data-step">
                  <span class="admin-data-step-icon">
                    @if (dataIngestSuccess) {
                      ✓
                    } @else if (dataIngestError) {
                      ✗
                    } @else if (dataIngestJob && jobIsActive(dataIngestJob)) {
                      ⏳
                    } @else if (dataIngestStarting) {
                      ⏳
                    } @else {
                      ·
                    }
                  </span>
                  <span>
                    <strong>Step {{ selectedDataSource?.upload?.supported ? 2 : 1 }} — Ingest.</strong>
                    @if (dataIngestSuccess) {
                      {{ dataIngestSuccess }}
                    } @else if (dataIngestError) {
                      {{ dataIngestError }}
                    } @else if (dataIngestJob) {
                      @switch (dataIngestJob.status) {
                        @case ('pending') {
                          Pending…
                        }
                        @case ('running') {
                          Ingesting ({{ dataIngestJob.progress }}%)…
                        }
                        @default {
                          {{ dataIngestJob.status }}
                        }
                      }
                    } @else if (dataIngestStarting) {
                      Starting…
                    } @else {
                      Not started.
                    }
                  </span>
                  @if (dataIngestJob && jobIsActive(dataIngestJob)) {
                    <button ngkButton color="warning" mode="outlined" size="sm" (click)="cancelDataIngest()">
                      Cancel
                    </button>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    }

    <!-- Jobs dashboard panel -->
    @if (activePanel === 'jobs') {
      <div class="admin-panel admin-panel--wide">
        <h3 class="admin-panel-title">Recent Jobs</h3>
        <p class="admin-panel-desc">Data upload and ingest jobs, most recent first.</p>

        <div class="admin-btn-row">
          <button ngkButton color="secondary" mode="outlined" size="sm" [disabled]="jobsLoading" (click)="loadJobs()">
            {{ jobsLoading ? 'Loading…' : 'Refresh' }}
          </button>
        </div>

        @if (jobsError) {
          <p class="admin-error">{{ jobsError }}</p>
        }
        @if (cancelError) {
          <p class="admin-error">{{ cancelError }}</p>
        }

        @if (!jobsLoading && recentJobs.length === 0 && !jobsError) {
          <p class="admin-empty">No jobs yet.</p>
        }

        @if (recentJobs.length > 0) {
          <div class="admin-table-wrap">
            <table class="admin-table">
              <thead>
              <tr>
                <th>Type</th>
                <th>Status</th>
                <th>Details</th>
                <th>Progress</th>
                <th>Started</th>
                <th>Completed</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                @for (job of recentJobs; track job.id) {
                  <tr class="admin-table-row--clickable" (click)="toggleJobDetails(job)">
                    <td>{{ jobTypeLabel(job) }}</td>
                    <td>
                      @switch (job.status) {
                        @case ('completed') {
                          <ngk-chip color="secondary" variant="solid" size="sm">Completed</ngk-chip>
                        }
                        @case ('failed') {
                          <ngk-chip color="warning" variant="solid" size="sm">Failed</ngk-chip>
                        }
                        @case ('cancelled') {
                          <ngk-chip color="warning" variant="solid" size="sm">Cancelled</ngk-chip>
                        }
                        @default {
                          <ngk-chip color="warning" variant="solid" size="sm">{{ job.status }}</ngk-chip>
                        }
                      }
                    </td>
                    <td>
                      <div>{{ jobMetadataSummary(job) || '—' }}</div>
                      @if (job.errorMessage) {
                        <div class="admin-error">{{ job.errorMessage }}</div>
                      }
                      @if (jobRowErrorCount(job) > 0) {
                        <div class="admin-job-row-errors">
                          {{ jobRowErrorCount(job) }} row {{ jobRowErrorCount(job) === 1 ? 'error' : 'errors' }}
                        </div>
                      }
                    </td>
                    <td>{{ job.progress }}</td>
                    <td>{{ job.startedAt | date:'short' }}</td>
                    <td>{{ job.completedAt ? (job.completedAt | date:'short') : '—' }}</td>
                    <td class="admin-table-actions" (click)="$event.stopPropagation()">
                      @if (jobIsActive(job)) {
                        <button
                          class="admin-toggle-btn admin-toggle-btn--demote"
                          [disabled]="cancelingJob === job.id"
                          (click)="cancelJob(job)"
                        >
                          {{ cancelingJob === job.id ? '…' : 'Cancel' }}
                        </button>
                      }
                    </td>
                  </tr>
                  @if (expandedJobId === job.id) {
                    <tr class="admin-job-details-row">
                      <td colspan="7">
                        <div class="admin-job-details">
                          <dl class="admin-job-details-grid">
                            <dt>Job ID</dt>
                            <dd>{{ job.id }}</dd>
                            <dt>Started</dt>
                            <dd>{{ job.startedAt | date:'medium' }}</dd>
                            <dt>Completed</dt>
                            <dd>{{ job.completedAt ? (job.completedAt | date:'medium') : '—' }}</dd>
                            <dt>Progress</dt>
                            <dd>{{ job.progress }}</dd>
                          </dl>

                          @if (job.errorMessage) {
                            <h4 class="admin-job-details-heading">Error</h4>
                            <pre class="admin-job-details-error">{{ job.errorMessage }}</pre>
                          }

                          @if (jobRowErrorCount(job) > 0) {
                            <h4 class="admin-job-details-heading">Row errors ({{ jobRowErrorCount(job) }})</h4>
                            @if (jobRowErrorTruncationNote(job)) {
                              <p class="admin-job-details-note">{{ jobRowErrorTruncationNote(job) }}</p>
                            }
                            @if (jobRowErrorDetails(job).length > 0) {
                              <ul class="admin-csv-errors">
                                @for (detail of jobRowErrorDetails(job); track $index) {
                                  <li>{{ detail }}</li>
                                }
                              </ul>
                            }
                          }

                          <h4 class="admin-job-details-heading">Metadata</h4>
                          <pre class="admin-job-details-json">{{ jobMetadataJson(job) }}</pre>
                        </div>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }


    <!-- Evidence Packet panel -->
    @if (activePanel === 'evidence') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Generate Evidence Packet</h3>
        <p class="admin-panel-desc">Generate an evidence packet PDF for a subject property in a county, with separate
          sales and equity comparables from the same county.</p>

        <div class="admin-form">
          <label class="admin-label" for="evidence-county">County</label>
          <select id="evidence-county" class="admin-select" [(ngModel)]="evidenceCounty">
            <option value="" disabled>Select county</option>
            @for (c of evidenceCountyOptions; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>

          <label class="admin-label admin-label--spaced" for="evidence-acct">Subject Parcel ID</label>
          <input
            id="evidence-acct"
            class="admin-input"
            type="text"
            placeholder="e.g. 1234567890123"
            [(ngModel)]="evidenceAccountNumber"
          />

          <label class="admin-label admin-label--spaced" for="evidence-sales-comps">Sales Comparable Parcel IDs</label>
          <p class="admin-panel-desc">Drives pages 2–3. Sales-comp pages repeat in batches of 5; enter as many as
            needed, one per line or separated by commas.</p>
          <textarea
            id="evidence-sales-comps"
            class="admin-input admin-textarea"
            placeholder="9876543210123&#10;1111111111111"
            [(ngModel)]="evidenceSalesComps"
          ></textarea>

          <label class="admin-label admin-label--spaced" for="evidence-equity-comps">Equity Comparable Parcel IDs</label>
          <p class="admin-panel-desc">Drives pages 4–5. Equity-comp pages repeat in batches of 6; enter as many as
            needed, one per line or separated by commas.</p>
          <textarea
            id="evidence-equity-comps"
            class="admin-input admin-textarea"
            placeholder="9876543210123&#10;1111111111111"
            [(ngModel)]="evidenceEquityComps"
          ></textarea>

          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="evidenceLoading || !evidenceCounty || !evidenceAccountNumber.trim() || (!evidenceSalesComps.trim() && !evidenceEquityComps.trim())"
              (click)="submitEvidencePacket()"
            >
              {{ evidenceLoading ? 'Generating…' : 'Generate PDF' }}
            </button>
          </div>
        </div>

        @if (evidenceSuccess) {
          <p class="admin-success">{{ evidenceSuccess }}</p>
        }
        @if (evidenceError) {
          <p class="admin-error">{{ evidenceError }}</p>
        }
      </div>
    }

    <!-- Evidence Batch panel -->
    @if (activePanel === 'evidenceBatch') {
      <div class="admin-panel admin-panel--wide">
        <h3 class="admin-panel-title">Generate Evidence Packets (Batch)</h3>
        <p class="admin-panel-desc">
          Pick the county, then paste or upload a padded CSV: one packet per row, with columns
          <code>subject, sales_1…sales_{{ batchSalesCols }}, equity_1…equity_{{ batchEquityCols }}</code>.
          Leave a cell empty when there are fewer comps. Header row is optional. The backend builds one ZIP for all
          packets.
        </p>

        <div class="admin-form">
          <label class="admin-label" for="evidence-batch-county">County</label>
          <select id="evidence-batch-county" class="admin-select" [(ngModel)]="evidenceBatchCounty">
            <option value="" disabled>Select county</option>
            @for (c of evidenceCountyOptions; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>

          <label class="admin-label admin-label--spaced" for="evidence-batch-year">Tax Year</label>
          <input
            id="evidence-batch-year"
            class="admin-input admin-input--short"
            type="text"
            placeholder="2026"
            [(ngModel)]="evidenceBatchYear"
          />

          <label class="admin-label admin-label--spaced" for="evidence-batch-csv-file">CSV File (optional)</label>
          <input
            id="evidence-batch-csv-file"
            class="admin-file-input"
            type="file"
            accept=".csv,text/csv"
            (change)="onEvidenceBatchCsvFile($event)"
          />

          <label class="admin-label admin-label--spaced" for="evidence-batch-csv">CSV</label>
          <p class="admin-panel-desc">
            Expected header (also the column order): <code>{{ evidenceBatchCsvHeader }}</code>
          </p>
          <textarea
            id="evidence-batch-csv"
            class="admin-input admin-textarea admin-textarea--tall"
            spellcheck="false"
            placeholder="1234567890123,9876543210123,1111111111111,,,,,,,,,5555555555555,,,,,,,,,"
            [(ngModel)]="evidenceBatchCsv"
            (ngModelChange)="validateEvidenceBatchCsv()"
          ></textarea>

          @if (evidenceBatchParseError) {
            <p class="admin-error">{{ evidenceBatchParseError }}</p>
          } @else if (evidenceBatchPreviewCount > 0) {
            <p class="admin-panel-desc">{{ evidenceBatchPreviewCount }} packet(s) parsed.</p>
          }

          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="evidenceBatchStarting || !evidenceBatchCanSubmit || (evidenceBatchJob !== null && jobIsActive(evidenceBatchJob))"
              (click)="submitEvidenceBatch()"
            >
              {{ evidenceBatchStarting ? 'Starting…' : 'Generate Batch' }}
            </button>
          </div>
        </div>

        @if (evidenceBatchJob && jobIsActive(evidenceBatchJob)) {
          @let batchMeta = evidenceBatchMetadata(evidenceBatchJob);
          <div class="admin-restore-status">
            <p class="admin-loading">
              @switch (evidenceBatchJob.status) {
                @case ('pending') {
                  Batch pending…
                }
                @case ('running') {
                  Building packets
                  @if (batchMeta.packetsCompleted !== null && batchMeta.packetsCompleted !== undefined && batchMeta.totalPackets !== null && batchMeta.totalPackets !== undefined) {
                    ({{ batchMeta.packetsCompleted }} / {{ batchMeta.totalPackets }})
                  }
                  …
                }
                @default {
                  Status: {{ evidenceBatchJob.status }}…
                }
              }
            </p>
            <div class="admin-btn-row">
              <button ngkButton color="warning" mode="outlined" size="sm" (click)="cancelEvidenceBatch()">
                Cancel
              </button>
            </div>
          </div>
        }

        @if (evidenceBatchJob && evidenceBatchJob.status === 'completed') {
          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="evidenceBatchDownloading"
              (click)="downloadEvidenceBatchZip(evidenceBatchJob.id)"
            >
              {{ evidenceBatchDownloading ? 'Downloading…' : 'Download ZIP again' }}
            </button>
          </div>
        }

        @if (evidenceBatchSuccess) {
          <p class="admin-success">{{ evidenceBatchSuccess }}</p>
        }
        @if (evidenceBatchError) {
          <p class="admin-error">{{ evidenceBatchError }}</p>
        }
      </div>
    }

    <!-- Case Steps panel -->
    @if (activePanel === 'steps') {
      <div class="admin-panel admin-panel--wide">
        <h3 class="admin-panel-title">Manage Case Steps</h3>
        <p class="admin-panel-desc">Look up case timeline steps by county and parcel IDs and update their status.</p>

        <div class="admin-form">
          <label class="admin-label" for="steps-county">County</label>
          <select id="steps-county" class="admin-select" [(ngModel)]="stepsCounty">
            <option value="" disabled>Select county</option>
            @for (c of publicCounties; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>

          <label class="admin-label admin-label--spaced" for="steps-input">Parcel IDs</label>
          <p class="admin-panel-desc">Enter parcel IDs in that county, one per line or separated by commas.</p>
          <textarea
            id="steps-input"
            class="admin-input admin-textarea"
            placeholder="1234567890&#10;0987654321"
            [(ngModel)]="stepsInput"
          ></textarea>

          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="stepsLoading || !stepsCounty || !stepsInput.trim()"
              (click)="querySteps()"
            >
              {{ stepsLoading ? 'Loading…' : 'Look Up Steps' }}
            </button>
          </div>
        </div>

        @if (stepsError) {
          <p class="admin-error">{{ stepsError }}</p>
        }

        @if (stepsAccounts.length > 0) {
          <div class="admin-filters">
            <input
              class="admin-input"
              type="text"
              placeholder="Filter by title, description, or account…"
              [(ngModel)]="stepsFilterTitle"
            />
            <select class="admin-select" [(ngModel)]="stepsFilterStatus">
              <option value="all">All statuses</option>
              <option value="complete">Complete</option>
              <option value="active">Active</option>
              <option value="pending">Pending</option>
            </select>
            <select class="admin-select" [(ngModel)]="stepsFilterStep">
              <option value="">All steps</option>
              @for (num of availableStepNumbers; track num) {
                <option [value]="num">Step {{ num }}</option>
              }
            </select>
          </div>

          <div class="admin-btn-row">
            <button
              ngkButton color="secondary" mode="solid" size="sm"
              [disabled]="bulkUpdating || allStepsFlat.length === 0"
              (click)="bulkUpdateSteps('complete')"
            >
              {{ bulkUpdating ? 'Updating…' : 'Complete All (' + allStepsFlat.length + ')' }}
            </button>
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="bulkUpdating || allStepsFlat.length === 0"
              (click)="bulkUpdateSteps('active')"
            >
              {{ bulkUpdating ? 'Updating…' : 'Activate All (' + allStepsFlat.length + ')' }}
            </button>
            <button
              ngkButton color="warning" mode="outlined" size="sm"
              [disabled]="bulkUpdating || allStepsFlat.length === 0"
              (click)="bulkUpdateSteps('pending')"
            >
              {{ bulkUpdating ? 'Updating…' : 'Reset All (' + allStepsFlat.length + ')' }}
            </button>
            <span class="admin-user-name">{{ allStepsFlat.length }} step(s)</span>
          </div>

          <div class="admin-table-wrap">
            <table class="admin-table">
              <thead>
              <tr>
                <th>Parcel ID</th>
                <th>County</th>
                <th>Email</th>
                <th>Step</th>
                <th>Title</th>
                <th>Description</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                @for (step of allStepsFlat; track step.id) {
                  <tr>
                    <td>{{ step.parcelId }}</td>
                    <td>{{ step.county }}</td>
                    <td class="admin-table-email">{{ step.email }}</td>
                    <td>{{ step.step }}</td>
                    <td>{{ step.title }}</td>
                    <td>{{ step.description }}</td>
                    <td>{{ step.date }}</td>
                    <td>
                      @switch (step.status) {
                        @case ('complete') {
                          <ngk-chip color="secondary" variant="solid" size="sm">Complete</ngk-chip>
                        }
                        @case ('active') {
                          <ngk-chip color="warning" variant="solid" size="sm">Active</ngk-chip>
                        }
                        @case ('pending') {
                          <span class="admin-user-name">Pending</span>
                        }
                      }
                    </td>
                    <td class="admin-table-actions">
                      @if (step.status !== 'complete') {
                        <button
                          class="admin-toggle-btn"
                          [disabled]="stepUpdating === step.id || bulkUpdating"
                          (click)="updateStepStatus(step, 'complete')"
                        >
                          {{ stepUpdating === step.id ? '…' : 'Complete' }}
                        </button>
                      }
                      @if (step.status !== 'active') {
                        <button
                          class="admin-toggle-btn"
                          [disabled]="stepUpdating === step.id || bulkUpdating"
                          (click)="updateStepStatus(step, 'active')"
                        >
                          {{ stepUpdating === step.id ? '…' : 'Activate' }}
                        </button>
                      }
                      @if (step.status !== 'pending') {
                        <button
                          class="admin-toggle-btn admin-toggle-btn--demote"
                          [disabled]="stepUpdating === step.id || bulkUpdating"
                          (click)="updateStepStatus(step, 'pending')"
                        >
                          {{ stepUpdating === step.id ? '…' : 'Reset' }}
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (allStepsFlat.length === 0) {
            <p class="admin-empty">No steps match the current filters.</p>
          }
        }

        @if (stepUpdateSuccess) {
          <p class="admin-success">{{ stepUpdateSuccess }}</p>
        }
        @if (stepUpdateError) {
          <p class="admin-error">{{ stepUpdateError }}</p>
        }
      </div>
    }

    <!-- Dedup Emails panel -->
    @if (activePanel === 'dedup') {
      <div class="admin-panel">
        <h3 class="admin-panel-title">Duplicate Emails</h3>
        <p class="admin-panel-desc">Find and merge users whose email addresses differ only by case (e.g. User&#64;Example.com
          vs user&#64;example.com).</p>

        @if (dupLoading) {
          <p class="admin-loading">Loading duplicate emails…</p>
        }

        @if (dupError) {
          <p class="admin-error">{{ dupError }}</p>
          <button ngkButton color="secondary" mode="outlined" size="sm" (click)="loadDuplicateEmails()">Retry</button>
        }

        @if (!dupLoading && !dupError && dupGroups.length === 0 && !dedupResult) {
          <p class="admin-empty">No duplicate emails found.</p>
          <div class="admin-btn-row">
            <button ngkButton color="secondary" mode="solid" size="sm" (click)="loadDuplicateEmails()">Refresh</button>
          </div>
        }

        @if (dupGroups.length > 0) {
          <p class="admin-panel-desc">Found {{ dupGroups.length }} group(s) of duplicate emails.</p>

          <div class="admin-dedup-groups">
            @for (group of dupGroups; track group.normalizedEmail) {
              <div class="admin-dedup-group">
                <div class="admin-dedup-group-header">
                  <span class="admin-user-email">{{ group.normalizedEmail }}</span>
                  <span class="admin-user-name">{{ group.variants.length }} variants</span>
                </div>
                <div class="admin-user-list">
                  @for (variant of group.variants; track variant.id) {
                    <div class="admin-user-row">
                      <div class="admin-user-info">
                        <span class="admin-user-email">{{ variant.email }}</span>
                        <span class="admin-user-name">Created: {{ variant.createdAt | date:'short' }}</span>
                      </div>
                      <div class="admin-user-actions">
                        @if (variant.isWinner) {
                          <ngk-chip color="secondary" variant="solid" size="sm">Keep</ngk-chip>
                        } @else {
                          <ngk-chip color="warning" variant="solid" size="sm">Merge</ngk-chip>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <div class="admin-btn-row">
            <button
              ngkButton color="warning" mode="solid" size="sm"
              [disabled]="dedupLoading"
              (click)="runDedup()"
            >
              {{ dedupLoading ? 'Merging…' : 'Merge All Duplicates' }}
            </button>
            <button
              ngkButton color="secondary" mode="outlined" size="sm"
              [disabled]="dedupLoading"
              (click)="loadDuplicateEmails()"
            >
              Refresh
            </button>
          </div>
        }

        @if (dedupResult) {
          <div class="admin-dedup-result">
            <p class="admin-success">Deduplication complete: {{ dedupResult.groupsMerged }} group(s)
              merged, {{ dedupResult.usersDeleted }} user(s) deleted.</p>
            @if (dedupResult.details.length > 0) {
              <div class="admin-user-list admin-dedup-details">
                @for (detail of dedupResult.details; track detail.normalizedEmail) {
                  <div class="admin-user-row">
                    <div class="admin-user-info">
                      <span class="admin-user-email">{{ detail.normalizedEmail }}</span>
                      <span class="admin-user-name">Kept: {{ detail.winnerId }}
                        · Merged: {{ detail.mergedIds.join(', ') }}</span>
                    </div>
                  </div>
                }
              </div>
            }
            <div class="admin-btn-row">
              <button ngkButton color="secondary" mode="outlined" size="sm" (click)="loadDuplicateEmails()">
                Check Again
              </button>
            </div>
          </div>
        }

        @if (dedupError) {
          <p class="admin-error">{{ dedupError }}</p>
        }
      </div>
    }

    <!-- County Mapping panel (prototype) -->
    @if (activePanel === 'countyMapping') {
      <div class="admin-panel admin-panel--wide">
        <h3 class="admin-panel-title">County Mapping (Preview)</h3>
        <p class="admin-panel-desc">
          Fetch, Save to server, and Ingest data below all act for real: they stage real files and can
          write real rows to property_assessment. To onboard a county, work top to bottom: pick a county
          or start blank, fetch its data file(s), map each Kin field to a source column, save, then ingest.
        </p>

        <div class="admin-form">
          <h4 class="admin-label">Start from</h4>
          <ngk-select
            [value]="countyMappingTemplate"
            (valueChange)="onCountyMappingTemplateChange($event)"
            panelClass="county-mapping-select-panel"
          >
            <ngk-select-option value="blank">{{ blankCountyMappingLabel }}</ngk-select-option>
            @for (group of countyMappingStateGroups; track group.stateName) {
              <ngk-select-option-group [label]="group.stateName">
                @for (entry of group.entries; track entry.jurisdictionCode) {
                  <ngk-select-option [value]="entry.jurisdictionCode">{{ entry.label }}</ngk-select-option>
                }
              </ngk-select-option-group>
            }
          </ngk-select>
          @if (countyMappingStateGroupsError) {
            <p class="admin-error">{{ countyMappingStateGroupsError }}</p>
          }
        </div>

        <div class="admin-divider"></div>

        <div class="admin-form">
          <h4 class="admin-label">Server config</h4>
          <div class="admin-btn-row">
            <input
              class="admin-input"
              type="text"
              [(ngModel)]="countyMappingServerJurisdiction"
              placeholder="Jurisdiction code (e.g. HARRIS_TX)"
            />
            <input
              class="admin-input"
              type="text"
              [(ngModel)]="countyMappingServerState"
              placeholder="State (e.g. Texas)"
            />
            <button
              ngkButton
              color="secondary"
              mode="outlined"
              size="sm"
              [disabled]="countyMappingServerBusy"
              (click)="loadCountyMappingFromServer()"
            >
              Load from server
            </button>
            <button
              ngkButton
              color="primary"
              mode="outlined"
              size="sm"
              [disabled]="countyMappingServerBusy"
              (click)="saveCountyMappingToServer()"
            >
              Save to server
            </button>
          </div>
          @if (countyMappingServerStatus) {
            <p class="admin-panel-desc">{{ countyMappingServerStatus }}</p>
          }
          @if (countyMappingServerError) {
            <p class="admin-error">{{ countyMappingServerError }}</p>
          }
        </div>

        <div class="admin-divider"></div>

        <div class="admin-form">
          <h4 class="admin-label">Fetch data</h4>
          <p class="admin-panel-desc">
            Paste a link to one file (zip or flat) and fetch it, staging its contents and
            auto-detecting its columns. Does not ingest anything, map fields and save below, then
            use Ingest data once you're ready.
          </p>
          @if (countyMappingStagedLocation) {
            <p class="admin-panel-desc">Staged at: {{ countyMappingStagedLocation }}</p>
          }
          <div class="admin-btn-row">
            <input
              class="admin-input"
              type="text"
              [(ngModel)]="countyMappingFetchUrl"
              placeholder="File URL, e.g. https://example-cad.org/downloads/2026/parcels.zip"
            />
            <button
              ngkButton
              color="primary"
              mode="outlined"
              size="sm"
              [disabled]="countyMappingFetchStarting || isCountyMappingFetchActive"
              (click)="fetchCountyMappingUrl()"
            >
              Fetch
            </button>
            <button
              ngkButton
              color="secondary"
              mode="outlined"
              size="sm"
              [disabled]="countyMappingFetchStarting || isCountyMappingFetchActive"
              (click)="fetchAllCountyMappingUrls()"
            >
              Fetch all
            </button>
            @if (isCountyMappingFetchActive) {
              <button
                ngkButton
                color="secondary"
                mode="outlined"
                size="sm"
                (click)="cancelCountyMappingFetch()"
              >
                Cancel
              </button>
            }
          </div>
          <p class="admin-panel-desc">
            "Fetch all" re-fetches every URL already saved on this jurisdiction's source files, to
            refresh them from source.
          </p>
          @if (countyMappingFetchJob) {
            <p class="admin-panel-desc">
              {{ countyMappingFetchJob.status }}
              @if (countyMappingFetchSummary(countyMappingFetchJob)) {
                ({{ countyMappingFetchSummary(countyMappingFetchJob) }})
              }
            </p>
          }
          @if (countyMappingFetchError) {
            <p class="admin-error">{{ countyMappingFetchError }}</p>
          }
        </div>

        <div class="admin-divider"></div>

        <div class="admin-form">
          <h4 class="admin-label">Source files</h4>
          <p class="admin-panel-desc">
            The <strong>primary file</strong> (first in the list) drives the ingest: each of its rows becomes
            one property record, and every other file is only looked up by account number to fill in more
            fields. It must have exactly one row per parcel, like a county's main parcel or account file. If a
            file with several rows per parcel (owners, deeds) or no account column (code tables) is first,
            you'll get duplicate, missing, or broken records. Use ↑ ↓ to put the right file first.
          </p>
          <p class="admin-panel-desc">
            Order also decides which file a column comes from: a plain column name reads from the first
            file that has it. When several files share a column (e.g. <code>sqft</code> in both
            building files), prefix it with the file, like <code>buildings.csv:sqft</code>.
          </p>
          <p class="admin-panel-desc">
            Files fetched above appear here automatically with their columns already detected. Use
            "Add file" below only to correct a file's columns or delimiter by hand (remove it above
            first, then re-add it here). Every field below autocompletes from whatever columns are
            known for a file.
          </p>
          @if (countyMappingPrimaryFileLacksParcelId) {
            <p class="admin-error">
              The primary file, {{ countyMappingSourceFiles[0] }}, has no <code>{{ countyMappingParcelIdColumn }}</code>
              column, the one parcelId is copied from, so the ingest can't create one record per parcel from it.
              Move the file with one row per parcel to the top, or fix the parcelId mapping, before saving or
              ingesting.
            </p>
          }
          <div class="admin-btn-row">
            @for (file of countyMappingSourceFiles; track file; let i = $index, last = $last) {
              <span class="admin-chip-removable" [class.admin-chip-removable--primary]="i === 0" [title]="countyMappingSourceFileUrls[file] || 'No URL (manually declared)'">
                @if (i === 0) {
                  <span class="admin-chip-badge" title="Drives the ingest: one property record per row">Primary</span>
                }
                {{ file }}{{ columnCountFor(file) > 0 ? ' (' + columnCountFor(file) + ' cols' + (countyMappingSourceFileDelimiters[file] === 'fixedWidth' ? ', fixed-width)' : ')') : ' (no columns declared)' }}
                <button type="button" class="admin-chip-remove" [disabled]="i === 0" (click)="moveCountyMappingSourceFile(file, -1)" [attr.aria-label]="'Move ' + file + ' up'">↑</button>
                <button type="button" class="admin-chip-remove" [disabled]="last" (click)="moveCountyMappingSourceFile(file, 1)" [attr.aria-label]="'Move ' + file + ' down'">↓</button>
                <button type="button" class="admin-chip-remove" (click)="removeCountyMappingSourceFile(file)" [attr.aria-label]="'Remove ' + file">×</button>
              </span>
            }
            @if (countyMappingSourceFiles.length === 0) {
              <span class="admin-panel-desc">No source files yet.</span>
            }
          </div>
          <div class="admin-input-row">
            <input
              class="admin-input admin-input--medium"
              type="text"
              placeholder="File name, e.g. ACCOUNT_INFO.CSV"
              [(ngModel)]="countyMappingNewFileInput"
            />
          </div>
          <div class="admin-input-row">
            <input
              class="admin-input"
              type="text"
              placeholder="Paste this file's header row (tab, pipe, or comma separated)"
              [(ngModel)]="countyMappingNewFileHeaderInput"
              (keyup.enter)="addCountyMappingSourceFile()"
            />
            <button ngkButton color="secondary" mode="solid" size="sm" (click)="addCountyMappingSourceFile()">Add file</button>
          </div>
          @if (countyMappingNewFileError) {
            <p class="admin-error">{{ countyMappingNewFileError }}</p>
          }

          <p class="admin-panel-desc">
            For a fixed-width source (no delimiter), upload the vendor's field-layout
            spreadsheet (Field Name / Start / Length columns) instead of pasting a header
            row. It's matched to already-staged files by filename and applied automatically.
          </p>
          <label class="admin-label admin-label--spaced" for="county-layout-file">Field-layout spreadsheet (.xlsx)</label>
          <div class="admin-input-row">
            <input
              id="county-layout-file"
              class="admin-file-input"
              type="file"
              accept=".xlsx"
              [disabled]="countyMappingLayoutBusy"
              (change)="uploadCountyLayout($event)"
            />
          </div>
          @if (countyMappingLayoutStatus) {
            <p class="admin-panel-desc">{{ countyMappingLayoutStatus }}</p>
          }
          @if (countyMappingLayoutError) {
            <p class="admin-error">{{ countyMappingLayoutError }}</p>
          }
        </div>

        <div class="admin-divider"></div>

        @if (countyMappingKnownColumns.length > 0) {
          <p class="admin-panel-desc">
            {{ countyMappingAttentionCount }} of {{ kinFields.length }} fields don't reference any known column yet.
          </p>
        }

        <div class="admin-table-wrap">
          <table class="admin-table">
            <thead>
              <tr>
                <th>Kin field</th>
                <th>Transform</th>
                <th>Summary</th>
              </tr>
            </thead>
            <tbody>
              @for (group of kinFieldGroups; track group.name) {
                <tr class="admin-table-group-row">
                  <th colspan="3" scope="colgroup">{{ group.name }}</th>
                </tr>
                @for (field of group.fields; track field.key) {
                  <tr
                    class="admin-table-row--clickable"
                    [class.admin-table-row--selected]="countyMappingSelectedField === field.key"
                    [class.admin-table-row--needs-attention]="fieldNeedsAttention(countyMappingFields[field.key])"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'Edit mapping for ' + field.label"
                    (click)="selectCountyMappingField(field.key)"
                    (keydown.enter)="selectCountyMappingField(field.key)"
                    (keydown.space)="$event.preventDefault(); selectCountyMappingField(field.key)"
                  >
                    <td>{{ field.label }}</td>
                    <td>{{ transformTypeLabel(countyMappingFields[field.key].transformType) }}</td>
                    <td>
                      {{ mappingSummary(countyMappingFields[field.key]) }}
                      @if (fieldNeedsAttention(countyMappingFields[field.key])) {
                        <span class="admin-error"> (no known column referenced)</span>
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>

        <datalist id="county-mapping-columns">
          @for (col of countyMappingKnownColumns; track col) {
            <option [value]="col"></option>
          }
        </datalist>

        @if (countyMappingSelectedField) {
          <div class="admin-panel county-mapping-editor">
            <h4 class="admin-panel-title">Editing: {{ countyMappingSelectedFieldLabel }}</h4>

            <div class="admin-form">
              <label class="admin-label" for="county-mapping-transform-type">Transform type</label>
              <select
                id="county-mapping-transform-type"
                class="admin-select"
                [ngModel]="countyMappingSelectedMapping?.transformType"
                (ngModelChange)="setFieldTransformType($event)"
              >
                @for (option of transformTypeOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
              @if (countyMappingSelectedTypeDescription) {
                <p class="admin-panel-desc">{{ countyMappingSelectedTypeDescription }}</p>
              }
            </div>

            @for (spec of countyMappingSelectedParamSpecs; track $index) {
              <div class="admin-form">
                <label class="admin-label" [attr.for]="'county-mapping-param-' + $index">{{ spec.label }}</label>
                <input
                  [attr.id]="'county-mapping-param-' + $index"
                  class="admin-input"
                  type="text"
                  [attr.list]="spec.kind === 'literal' ? null : 'county-mapping-columns'"
                  [placeholder]="spec.placeholder ?? ''"
                  [ngModel]="countyMappingSelectedMapping?.params?.[$index] ?? ''"
                  (ngModelChange)="setFieldParam($index, $event)"
                />
              </div>
            }
          </div>
        }

        <div class="admin-divider"></div>

        <div class="admin-form">
          <h4 class="admin-label">Resulting config (this is what would be saved as data, not code)</h4>
          <pre class="county-mapping-json">{{ countyMappingConfigJson }}</pre>
        </div>

        <div class="admin-divider"></div>

        <div class="admin-form">
          <h4 class="admin-label">Ingest data</h4>
          <p class="admin-panel-desc">
            Saves the field mappings above, then runs the interpreter against the files already
            staged and writes the result to property_assessment.
          </p>
          <div class="admin-btn-row">
            <button
              ngkButton
              color="primary"
              mode="outlined"
              size="sm"
              [disabled]="!countyMappingStagedLocation || countyMappingIngestStarting || isCountyMappingIngestActive"
              (click)="startCountyMappingIngest()"
            >
              Ingest data
            </button>
            @if (isCountyMappingIngestActive) {
              <button
                ngkButton
                color="secondary"
                mode="outlined"
                size="sm"
                (click)="cancelCountyMappingIngest()"
              >
                Cancel
              </button>
            }
          </div>
          @if (countyMappingIngestJob) {
            <p class="admin-panel-desc">
              {{ countyMappingIngestJob.status }}
              @if (countyMappingIngestSummary(countyMappingIngestJob)) {
                ({{ countyMappingIngestSummary(countyMappingIngestJob) }})
              }
            </p>
          }
          @if (countyMappingIngestError) {
            <p class="admin-error">{{ countyMappingIngestError }}</p>
          }
        </div>
      </div>
    }

  </main>
</div>
